import React from "react";
import Card from "@material-ui/core/Card";
import blueGrey from "@material-ui/core/colors/blueGrey";
const blueGrey200 = blueGrey["200"];

const style = {
  height: 85,
  marginBottom: 16,
  background: blueGrey200,
};

export default () => <Card style={style} />;



// WEBPACK FOOTER //
// ./src/dashboard/BadgePlaceholder.js